import { fromBlob } from 'image-resize-compress';

//stackoverflow.com/questions/3971841/how-to-resize-images-proportionally-keeping-the-aspect-ratio/14731922#14731922

export function calculateAspectRatioFit(srcWidth: number, srcHeight: number, maxWidth: number, maxHeight: number) {
  const ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
  return { width: srcWidth * ratio, height: srcHeight * ratio };
}

/**
 * THIS FUNCTION AUTOMATICALLY RESIZES TO MAX DIMENSIONS ON ATLEAST 1 DIMENSION WHILE KEEPING ASPECT RATIO

 */
export async function resizeImage(maxWidth: number, maxHeight: number, imgBlob: Blob) {
  const bmp = await createImageBitmap(imgBlob);
  const { width, height } = bmp;
  bmp.close(); // free memory

  let newWidth = width;
  let newHeight = height;
  if (width > maxWidth || height > maxHeight) {
    const { width: resWidth, height: resHeight } = calculateAspectRatioFit(width, height, maxWidth, maxHeight);
    newWidth = resWidth;
    newHeight = resHeight;
  }
  return await fromBlob(imgBlob, 100, newWidth, newHeight);
}
